import { api } from './api';

// Define a service using a base URL and expected endpoints
export const authApi = api.injectEndpoints({
  reducerPath: 'authApi',
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: ({ login, password }) => ({
        url: 'api/auth/token',
        method: 'POST',
        headers: {
          Authorization: `Basic ${btoa(`${login}:${password}`)}`
        }
      })
    }),
    getUserDetails: builder.mutation({
      query: () => ({
        url: `api/auth/userDetails`,
        method: 'GET'
      }),
      invalidatesTags: ['ConfFiles']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSignInMutation, useGetUserDetailsMutation } = authApi;
